import { render } from "./ObstetricsAndGynaecology.vue?vue&type=template&id=4c5988e1"
import script from "./ObstetricsAndGynaecology.vue?vue&type=script&lang=ts"
export * from "./ObstetricsAndGynaecology.vue?vue&type=script&lang=ts"
script.render = render

export default script